import DhtmlPopup, {ElementRelativeInTheContainerPositioning, ElementRelativePositioning} from "../dhtml_popup";
import {addClass, removeClass, isEscapePressed, cancelBubble} from "../atBrowserUtils";

/**
 * Popup for filter words on user selector
 */
export default function FilterWordsPopup () {}

FilterWordsPopup.prototype = new DhtmlPopup();

/**
 * @param divId dom id of root element of popup
 * @param relativeButtonId dom id of button relative to popup
 * @param containerId dom id of container where popup and relative button are placed
 * @param canUseContainerIdForPositioning defines if we should use container id for positioning FilterWordsPopup
 * @param innerComponentEl inner component element
 * @param onHideCallback this function will be called right before popup is hidden
 * If passes null it means that there is no container
 */
FilterWordsPopup.prototype.initAndRender = function ( divId, relativeButtonId, containerId, canUseContainerIdForPositioning,
                                                      innerComponentEl, onHideCallback )
{
    DhtmlPopup.call( this, divId );

    this.popupId = divId;

    if (canUseContainerIdForPositioning) {
        this.setPositioningStrategy(new ElementRelativeInTheContainerPositioning(relativeButtonId, containerId));
    } else {
        this.setPositioningStrategy(new ElementRelativePositioning(relativeButtonId));
    }

    var context = this;

    var commonDiv = document.createElement("div");
    commonDiv.id = this.popupId;
    commonDiv.className = "filterUsersPopup";
    var filterTable = document.createElement("table");
    filterTable.className = "filterTable";
    var filterTBody = document.createElement("tbody");
    var outerTr = document.createElement("tr");
    var innerComponentOuterTd = document.createElement("td");
    innerComponentOuterTd.className = "filterInputTableCell";
    this.innerComponentOuterTd = innerComponentOuterTd;
    var closeTd = document.createElement("td");
    closeTd.className = "closeFilterPanelButton";
    var closeSpan = document.createElement("span");

    commonDiv.appendChild(filterTable);
    filterTable.appendChild(filterTBody);
    filterTBody.appendChild(outerTr);
    outerTr.appendChild(innerComponentOuterTd);
    outerTr.appendChild(closeTd);
    innerComponentOuterTd.appendChild(innerComponentEl);
    closeTd.appendChild(closeSpan);

    document.getElementById(containerId).appendChild(commonDiv);

    this.closeButton = closeSpan;
    this.closeButton.onmouseover = function() {addClass(this, "hoverButton")};
    this.closeButton.onmouseout = function() {removeClass(this, "hoverButton")};
    this.closeButton.onclick = function() { context.hide(); };

    this.innerComponentOuterTd.onkeyup = function(e) {
        if (context.isHideByEscape(e))
        {
            cancelBubble(e);
            context.hide();
        }
    };

    this.shown = false;
    this.onHideCallback = onHideCallback;

    return this;
};

FilterWordsPopup.prototype.hide = function() {
    this.onHideCallback();
    DhtmlPopup.prototype.hide.call(this);
    this.shown = false;
};

FilterWordsPopup.prototype.hideWithoutCallback = function()
{
    DhtmlPopup.prototype.hide.call(this);
    this.shown = false;
};

FilterWordsPopup.prototype.show = function(offsetX, offsetY, width, height, isOriginAtBottom) {
    DhtmlPopup.prototype.show.call(this, offsetX, offsetY, width, height, isOriginAtBottom);
    this.shown = true;
};

/**
 * Defines that escape is pressed now and popup must be hidden due to this fact
 * @param event
 */
FilterWordsPopup.prototype.isHideByEscape = function(event) {
    return this.shown && window.event && isEscapePressed(event);
};

FilterWordsPopup.prototype.isShown = function() {
    return this.shown;
};



// WEBPACK FOOTER //
// ./web/js/controls/filter_words_popup.js